/**
 * Shared constants for the application
 */

// Skeleton loading color - used for loading placeholders
// Supports both light and dark modes
export const SKELETON_COLOR = 'bg-default-200 dark:bg-default-100 animate-pulse';

// Legacy alias for backward compatibility
export const SKELETON_COLOR_STATIC = 'bg-default-200 dark:bg-default-100';

/**
 * Design System Tokens
 * Standardized radius and shadow values for consistent UI
 */

// Border Radius Tokens
export const RADIUS = {
  none: 'rounded-none',
  sm: 'rounded-sm',        // 2px
  md: 'rounded-md',        // 6px
  lg: 'rounded-lg',        // 8px
  xl: 'rounded-xl',        // 12px
  '2xl': 'rounded-2xl',    // 16px
  '3xl': 'rounded-3xl',    // 24px
  full: 'rounded-full',    // 9999px
} as const;

// Shadow Tokens
export const SHADOW = {
  none: 'shadow-none',
  sm: 'shadow-sm',         // Subtle shadow for hover states
  md: 'shadow-md',         // Default shadow for cards and components
  lg: 'shadow-lg',         // Prominent shadow for containers and modals
  xl: 'shadow-xl',         // Strong shadow for tooltips and overlays
} as const;

// Component-specific design combinations
export const DESIGN_TOKENS = {
  // Cards
  card: `${RADIUS['2xl']} ${SHADOW.md}`,

  // Buttons and interactive elements
  button: `${RADIUS.lg} ${SHADOW.sm}`,

  // Form inputs
  input: `${RADIUS.lg} ${SHADOW.none}`,

  // Navigation items
  navItem: `${RADIUS.lg} ${SHADOW.none}`,

  // Main containers
  container: `${RADIUS.xl} ${SHADOW.lg}`,

  // Avatars and profile images
  avatar: RADIUS.full,

  // Loading spinners
  spinner: RADIUS.full,

  // Modal and overlay elements
  modal: `${RADIUS.xl} ${SHADOW.xl}`,
} as const;

